module.exports = __webpack_public_path__ + "d55f56d53ebd9516c26a5b4357a3992a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/numbers/2.png
// module id = 3427
// module chunks = 0